import firebase from 'firebase/app';
import 'firebase/database';

import config from './config';

const app = firebase.initializeApp(config);

export const database = app.database();
